///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.js-time-entry')) {
      document.querySelector('.process-review-form').addEventListener('click', (e) => {
        const target = e.target;

        if (target.classList.contains('js-focus-select')) {
          const selectedFocus = new SelectedFocus(target);

          selectedFocus.enforceRequiredField(target);

          target.addEventListener('input', function() {
            selectedFocus.enforceRequiredField(target);
          });
        } else if (target.classList.contains('js-classroom-select')) {
          const selectedClassroom = new SelectedClassroom(target);

          selectedClassroom.toggleClassroomRequirement(target);

          target.addEventListener('input', function() {
            selectedClassroom.toggleClassroomRequirement(target);
          });
        }
      });

      document.querySelector('.process-review-form').addEventListener('keyup', (e) => {
        const target = e.target;

        if (target.classList.contains('js-comment-field')) {
          const commentInput = new CommentInput(target);

          commentInput.toggleCommentRequirement(target);
        }
      });
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Constructors
  //
  ///////////////////////////////////////////////////////////////////

  function CommentInput(e) {
    this.focusSelect = e.parentElement
                        .parentElement
                        .previousElementSibling
                        .querySelector('.js-focus-select');
  }

  function SelectedClassroom(e) {
    this.focusSelect = e.parentElement
                        .previousElementSibling
                        .previousElementSibling
                        .querySelector('.js-focus-select');
  }

  function SelectedFocus(e) {
    this.commentField  = e.parentElement
                          .parentElement
                          .nextElementSibling
                          .querySelector('.js-comment-field');

    this.classroomSelect = e.parentElement
                            .nextElementSibling
                            .nextElementSibling
                            .querySelector('.js-classroom-select');
  }



  ///////////////////////////////////////////////////////////////////
  //
  // Prototype Definitions
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Toggles border and requirement
  //               on comment field based on comment
  //               value and associated focus value.
  //
  CommentInput.prototype.toggleCommentRequirement = function(e) {
    if (this.focusSelect && this.focusSelect.value == 'Other') {
      if (e.value != '') {
        removeRequirement(e);
      } else if (e.value == '') {
        enforceRequirement(e);
      }
    }
  };

  ///////////////////////////////////////////////
  //
  // Description - Toggles border and requirement on classrom
  //               dropdown based on classroom dropdown selection
  //               and associated focus value.
  //
  SelectedClassroom.prototype.toggleClassroomRequirement = function(e) {
    const requiredFoci = ['Classroom Observation', 'Ratio/Group Size', 'Staff Interview'];

    if (this.focusSelect && requiredFoci.includes(this.focusSelect.value)) {
      if (e.value != '') {
        removeRequirement(e);
      } else if (e.value == '') {
        enforceRequirement(e);
      }
    }
  };

  ///////////////////////////////////////////////
  //
  // Description - Toggles borders and requirements
  //               on classroom field and comment
  //               based on selected focus value
  //               and corresponding required fields.
  //
  SelectedFocus.prototype.enforceRequiredField = function(e) {
    const requiredFoci = ['Classroom Observation', 'Ratio/Group Size', 'Staff Interview'];

    // Check the selected focus and remove requirement emphasis for any
    // non-applicable requirements. If there is a required field and the
    // value isn't present, add the requirement emphasis.
    if (e.value == 'Other') {
      removeRequirement(this.classroomSelect);

      if (this.commentField.value == '') {
        enforceRequirement(this.commentField);
      }
    } else if (requiredFoci.includes(e.value)) {
      removeRequirement(this.commentField);

      if (this.classroomSelect.value == '') {
        enforceRequirement(this.classroomSelect);
      }
    } else {
      removeRequirement(this.commentField);
      removeRequirement(this.classroomSelect);
    }
  };



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Removes border and requirment
  //               settings from non-required field
  //
  function removeRequirement(targetField) {
    targetField.classList.remove('border', 'border-warning');
    targetField.removeAttribute("required");
  }

  ///////////////////////////////////////////////
  //
  // Description - Applies border and requirement
  //               settings to required field
  //
  function enforceRequirement(targetField) {
    targetField.classList.add('border', 'border-warning');
    targetField.setAttribute("required", "required");
  }
}());
